import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails  from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ListItem from '@material-ui/core/ListItem';
import StepQuestionList from './StepQuestionList';
import RaspaCycles from "./RaspaCycles";
import {renderDateTimeToListItem, renderMilisecondsToTimeDuration} from "../../utils/datetimehelp";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import RoitreadCycles from "./RoitreadCycles";

const styles = theme => ({
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(1) * 2,
  },
  fullWidth: {
    width: '100%',
  },

    expansionPanelSummaryRoot: {
      height: '40px',
         backgroundColor: '#cacaca',
        //backgroundColor: '#85b4d5',
      //  backgroundColor: '#f5e0b2',  // amarelo opaco
        // backgroundColor: '#a4c8e0',
         // backgroundColor: COLOR_chart_series_first_line,
        //backgroundColor: '#387199'

    },

    expansionPanelSummaryContent: {
            display: 'flex',
            justifyContent: 'space-between',

    },

});

class ProcessDetails extends Component {

 renderResultado( tipoResposta, resultado) {
   // console.log("RENDER RESULTADO", tipoResposta, resultado);
   switch(tipoResposta) {
     case 1: return resultado
     case 2: return resultado
     default: return ""
   }
 }

 classAlertResultado(step) {
     console.log("classAlert", step);
     let classAlertResultado =  {flexGrow:4, flexShrink:0, flexBasis:'33.33%',justifyContent:'space-between'};
     if (step.ordemServicoEtapa.processoEtapa.etapaId == 17 && step.ordemServicoEtapa.resultado < 20) {
         classAlertResultado = { ...classAlertResultado, backgroundColor: '#f57e7e', color: 'ghostwhite'}
     }
     return classAlertResultado;
}

    renderStepAction(step) {
        if (step.ordemServicoEtapa.processoEtapa.etapaId == 22 ) {

            if (step.ordemServicoEtapa.maquinaId !== 0 ) {
                const a = step.ordemServicoEtapa.maquinaId;
                const c = step.ordemServicoEtapa.maquinaCiclo;
                return (
                    <React.Fragment>
                            <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                                <Typography  style={{fontSize: '0.8rem'}}>AUTOCLAVE</Typography>
                                <Typography  style={{fontSize: '0.8rem'}}>{a}</Typography>
                            </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>CICLO</Typography>
                            <Typography  style={{fontSize: '0.8rem'}}>{c}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>POSICAO</Typography>
                            <Typography  style={{fontSize: '0.8rem'}}>{step.ordemServicoEtapa.maquinaPosicao}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'center'}}>
                            <Button
                                component={Link}
                                to={`/autoclave/ciclo/${a}/${c}`}
                                style={{ textAlign:'center', alignContent: 'center'}}
                            >Dados do ciclo</Button>
                        </ListItem>
                    </React.Fragment>
                );
            }
            if (step.ordemServicoEtapa.ordemServicoEtapaQuestaos) {

                const a = step.ordemServicoEtapa.ordemServicoEtapaQuestaos.find(q => q.processoEtapaQuestao.tipoPergunta == 221).resposta;
                const c = step.ordemServicoEtapa.ordemServicoEtapaQuestaos.find(q => q.processoEtapaQuestao.tipoPergunta == 222).resposta;
                return (
                    <ListItem style={{display:'flex', justifyContent:'center'}}>
                        <Button
                                component={Link}
                                to={`/autoclave/ciclo/${a}/${c}`}
                                style={{ textAlign:'center', alignContent: 'center'}}
                            >Dados do ciclo
                        </Button>
                    </ListItem>);
            }

           return null;
        }
    }


  render () {
    const { name, descricao, steps, classes } = this.props;

    console.log("processDetails: ", steps);
   return (
      <React.Fragment>
        {/*<Typography variant="subheading">{name}</Typography>*/}
        <Typography>{descricao}</Typography>
        {steps
            .sort( (a,b) => {
                var aSize = (a.DTInicioProducao);
                var bSize = (b.DTInicioProducao);

                return (aSize < bSize) ? -1 : 1;

            })
            .map((step, index) => {
            console.log("step", step);

            return (
          <Accordion key={index} style={{margin: '10px'}}>
            <AccordionSummary  classes={{
                root: classes.expansionPanelSummaryRoot,
                content: classes.expansionPanelSummaryContent
            }}   expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="subtitle1" style={{fontSize: '1.3rem'}}>{`${index + 1}. ${step.descricao.toUpperCase()} `}</Typography>
                {/*${step.ordemServicoEtapa.processoEtapaId} ${step.ordemServicoEtapa.processoEtapa.sequencia}*/}

            </AccordionSummary>
            <AccordionDetails  style={{display:"flex", flexFlow:"row wrap"}}>
                <Card style={{display:"flex", flexGrow:12, flexFlow:"row wrap"}}>
                    <Card style={{flexGrow:4, flexShrink:0, flexBasis:'33.33%', justifyContent:'space-between'}}>
                        <StepQuestionList questions={step.questions}/>
                        <Typography> Observações: {step.observacoes}</Typography>
                    </Card>
                  <Card style={{flexGrow:4, flexShrink:0, flexBasis:'33.33%', justifyContent:'space-between'}} >
                          {renderDateTimeToListItem('INICIO:', step.DTInicioProducao)}
                          {renderDateTimeToListItem('CONCLUIDO:', step.DTFimProducao)}
                      <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                          <Typography style={{fontSize: '0.8rem'}}>DURACAO:</Typography>
                          <Typography style={{fontSize: '1.1rem'}}>{renderMilisecondsToTimeDuration(new Date(step.DTFimProducao).getTime() - new Date(step.DTInicioProducao).getTime())}</Typography>
                      </ListItem>
                      <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                          <Typography style={{fontSize: '0.8rem'}}>OPERADOR:</Typography>
                          <Typography style={{fontSize: '1.1rem'}}>{step.operador? step.operador.nome.toUpperCase() : (step.operadorId? step.operadorId : '')}</Typography>
                      </ListItem>
                      { step.estacaoTrabalhoId &&
                          <ListItem style={{display: 'flex', justifyContent: 'space-between'}}>
                              <Typography style={{fontSize: '0.8rem'}}>ESTACAO:</Typography>
                              <Typography
                                  style={{fontSize: '1.1rem'}}>{step.estacaoTrabalhoId ? step.estacaoTrabalhoId :  ''}</Typography>
                          </ListItem>
                      }
                      <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                          <Typography style={{fontSize: '0.8rem'}}>#Local | id | pe:</Typography>
                          <Typography style={{fontSize: '0.6rem'}}>{step.localId? step.localId : ''} | {step.id} | {step.ordemServicoEtapa.processoEtapaId}</Typography>
                      </ListItem>
                  </Card>
                    {/*// ghostwhite  #f57e7e*/}
                  <Card style={this.classAlertResultado(step)}>
                       <Typography style={{textAlign:"center",  marginTop: '10px'}}>RESULTADO</Typography>
                       <Typography variant="h4" style={{textAlign:"center"}}> { this.renderResultado(step.ordemServicoEtapa.processoEtapa.tipoResultado, step.ordemServicoEtapa.resultado) }</Typography>
                      <Typography variant="subtitle2" style={{textAlign:"center"}}> {step.ordemServicoEtapa.processoEtapa.unidadeMedidaResultado?step.ordemServicoEtapa.processoEtapa.unidadeMedidaResultado : ''} </Typography>
                      {this.renderStepAction(step)}
                  </Card>
                    <RaspaCycles cycles={step.ordemServicoEtapa.raspaCiclos}/>
                    <RoitreadCycles cycles={step.ordemServicoEtapa.roitreadCiclos}/>
              </Card>


                {/*<Typography variant="caption" style={{alignContent:'right', textAlign: 'bottom'}}>[{step.id}]</Typography>*/}


            </AccordionDetails>
          </Accordion>
        ) })}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ProcessDetails);
